import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Descarga el kit',
    desc: 'Recibes el protocolo PDF, los guiones y el tracker de inmediato.'
  }, {
    num: '02',
    title: 'Firma tu contrato',
    desc: 'Estableces tu compromiso de hierro de 30 días.'
  }, {
    num: '03',
    title: 'Sigue el mapa',
    desc: 'Cada día tienes una lectura corta y una acción concreta para blindar tu paz.'
  }];
  return <section className="py-24 relative pt-[30px] pb-[30px]" data-id="element-84">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-black text-brand-white uppercase tracking-tight" data-id="element-87">
            Cómo Funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-88">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-89" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-90">
              <div className="w-24 h-24 rounded-full bg-brand-dark border border-brand-gold/20 flex items-center justify-center mb-6 relative z-10 box-glow-gold" data-id="element-91">
                <span className="text-3xl font-black text-brand-gold" data-id="element-92">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-bold text-brand-white mb-3" data-id="element-93">
                {step.title}
              </h3>
              <p className="text-brand-gray" data-id="element-94">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}